import { pageOf, postSchema, postSummarySchema } from "@shared/contracts";
import { request } from "../../platform/api/request";

const postPageSchema = pageOf(postSummarySchema);

export function fetchPosts(cursor: string | null, signal: AbortSignal) {
  const query = cursor ? `?cursor=${encodeURIComponent(cursor)}` : "";
  return request(`/posts${query}`, postPageSchema, { signal });
}

export function fetchPost(slug: string, signal: AbortSignal) {
  return request(`/posts/${encodeURIComponent(slug)}`, postSchema, { signal });
}
